import React from 'react';
import NotificationBell from '@/assets/icons/NotificationBell';
import { Link } from 'react-router-dom';
import ArrowRight from '@/assets/icons/ArrowRight';

const ActivitiesList = ({ items }) => {
  const formatNorwegianDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    const diffMs = now - date;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffHours < 1) {
      return 'akkurat nå';
    }

    if (diffHours < 24) {
      return diffHours === 1 ? '1 time siden' : `${diffHours} timer siden`;
    }

    if (diffDays < 7) {
      if (diffDays === 1) return 'Én dag siden';
      if (diffDays === 2) return 'To dager siden';
      return `${diffDays} dager siden`;
    }

    return date.toLocaleDateString('no-NO', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  };
  if (!items || items.length === 0) return null;
  return (
    <div>
      <h3 className="text-xl font-medium">Aktivitet</h3>
      <p className="text-[15px] opacity-[65%]">
        Det siste som har skjedd i ditt Boligmappa-univers
      </p>
      <div className="mt-2">
        {items
          .reverse()
          .slice(0, 5)
          .map((el) => (
            <Link
              to={`/personal-area/dashboard/notifications/${el.id}`}
              key={el.id}
              className="flex items-center justify-between gap-4 py-4 border-b last:border-b-0 transition duration-300"
            >
              <div className="p-3 border rounded-lg bg-white">
                <NotificationBell />{' '}
              </div>
              <div className="w-full">
                <h4 className="text-base font-medium">{el.title}</h4>
                <p className="text-base opacity-[65%]">
                  {formatNorwegianDate(el.date)}
                </p>
              </div>
              <ArrowRight width="33" height="33" stroke="#22222266" />
            </Link>
          ))}
      </div>
      {/* {items.length > 5 && ( */}
      {/*   <Link */}
      {/*     to="/dashboard/notifications" */}
      {/*     className="opacity-[65%] border-b border-gray-500" */}
      {/*   > */}
      {/*     Se alle */}
      {/*   </Link> */}
      {/* )} */}
    </div>
  );
};

export default ActivitiesList;
